import { Skeleton } from "antd";

export default function LoadingComp() {
  return (
    <div>
      <Skeleton active />
    </div>
  );
}
